// packages/sdk/client/src/index.ts
import { Config as Config3 } from "@dxos/config";
import { generateSeedPhrase } from "@dxos/credentials";
import { TYPE_SCHEMA, Item, ItemFilterDeleted, ResultSet, Schema } from "@dxos/echo-db";
export * from "@dxos/echo-schema";
import { PublicKey as PublicKey7 } from "@dxos/keys";
import { DocumentModel as DocumentModel2 } from "@dxos/document-model";
import { ApiError as ApiError6 } from "@dxos/errors";
import { Invitation as Invitation6, SpaceMember, SpaceState as SpaceState2, SystemStatus as SystemStatus2 } from "@dxos/protocols/proto/dxos/client/services";
import { ShellDisplay as ShellDisplay3, ShellLayout as ShellLayout2 } from "@dxos/protocols/proto/dxos/iframe";

// packages/sdk/client/src/packlets/client/client.ts
import assert7 from "@dxos/node-std/assert";
import { inspect as inspect3 } from "@dxos/node-std/util";
import { Event as Event7, MulticastObservable as MulticastObservable6, synchronized as synchronized2, Trigger as Trigger4 } from "@dxos/async";
import { Config as Config2 } from "@dxos/config";
import { inspectObject as inspectObject3 } from "@dxos/debug";
import { DocumentModel } from "@dxos/document-model";
import { ApiError as ApiError5 } from "@dxos/errors";
import { PublicKey as PublicKey6 } from "@dxos/keys";
import { log as log8 } from "@dxos/log";
import { ModelFactory } from "@dxos/model-factory";
import { trace as trace5 } from "@dxos/protocols";
import { SystemStatus } from "@dxos/protocols/proto/dxos/client/services";
import { TextModel } from "@dxos/text-model";

// packages/sdk/client/src/version.ts
var DXOS_VERSION = "0.1.35";

// packages/sdk/client/src/packlets/devtools/devtools.ts
import { log } from "@dxos/log";
import { createBundledRpcServer } from "@dxos/rpc";
var port = {
  send: async (message) => window.postMessage({
    data: Array.from(message),
    source: "dxos-client"
  }, "*"),
  subscribe: (callback) => {
    const handler = (event) => {
      if (event.source !== window) {
        return;
      }
      const message = event.data;
      if (typeof message !== "object" || message === null || message.source !== "content-script") {
        return;
      }
      callback(new Uint8Array(message.data));
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }
};
var createDevtoolsRpcServer = async (client, clientServices) => {
  let server;
  window.__DXOS__ = {
    client,
    openClientRpcServer: async () => {
      if (server) {
        log("Closing existing client RPC server.", {}, {
          file: "devtools.ts",
          line: 53,
          scope: void 0,
          callSite: (f, a) => f(...a)
        });
        await server.close();
      }
      log("Opening devtools client RPC server...", {}, {
        file: "devtools.ts",
        line: 57,
        scope: void 0,
        callSite: (f, a) => f(...a)
      });
      server = createBundledRpcServer({
        services: clientServices.descriptors,
        handlers: clientServices.services,
        port
      });
      await server.open().catch((err) => {
        log.error(`Failed to open RPC server: ${err}`, {}, {
          file: "devtools.ts",
          line: 65,
          scope: void 0,
          callSite: (f, a) => f(...a)
        });
        return false;
      });
      log("Opened devtools client RPC server.", {}, {
        file: "devtools.ts",
        line: 69,
        scope: void 0,
        callSite: (f, a) => f(...a)
      });
      return true;
    }
  };
};

// packages/sdk/client/src/packlets/proxies/echo-proxy.ts
import assert4 from "@dxos/node-std/assert";
import { inspect } from "@dxos/node-std/util";
import { Event as Event2, scheduleTask, Trigger as Trigger2, MulticastObservable as MulticastObservable3 } from "@dxos/async";
import { Context as Context2 } from "@dxos/context";
import { failUndefined, inspectObject, todo as todo2 } from "@dxos/debug";
import { DatabaseRouter } from "@dxos/echo-schema";
import { ApiError as ApiError2, SystemError } from "@dxos/errors";
import { PublicKey as PublicKey2 } from "@dxos/keys";
import { log as log3 } from "@dxos/log";
import { trace } from "@dxos/protocols";
import { Invitation as Invitation4 } from "@dxos/protocols/proto/dxos/client/services";
import { ComplexMap } from "@dxos/util";

// packages/sdk/client/src/packlets/invitations/encoder.ts
import base from "base-x";
import { schema } from "@dxos/protocols";
var base62 = base("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
var codec = schema.getCodecForType("dxos.client.services.Invitation");
var InvitationEncoder = class {
  static decode(text) {
    return codec.decode(base62.decode(text));
  }
  static encode(invitation) {
    return base62.encode(codec.encode({
      invitationId: invitation.invitationId,
      type: invitation.type,
      kind: invitation.kind,
      authMethod: invitation.authMethod,
      swarmKey: invitation.swarmKey,
      state: invitation.state,
      timeout: invitation.timeout
    }));
  }
};

// packages/sdk/client/src/packlets/invitations/invitations.ts
import assert from "@dxos/node-std/assert";
import { MulticastObservable } from "@dxos/async";
import { Invitation } from "@dxos/protocols/proto/dxos/client/services";
var AUTHENTICATION_CODE_LENGTH = 6;
var INVITATION_TIMEOUT = 3 * 6e4;
var ON_CLOSE_DELAY = 1e3;
var CancellableInvitationObservable = class extends MulticastObservable {
  constructor({ subscriber, initialInvitation, onCancel }) {
    super(subscriber, initialInvitation);
    this._onCancel = onCancel;
  }
  cancel() {
    return this._onCancel();
  }
};
var AuthenticatingInvitationObservable = class extends CancellableInvitationObservable {
  constructor({ subscriber, initialInvitation, onCancel, onAuthenticate }) {
    super({
      subscriber,
      initialInvitation,
      onCancel
    });
    this._onAuthenticate = onAuthenticate;
  }
  async authenticate(authCode) {
    return this._onAuthenticate(authCode);
  }
};
var wrapObservable = async (observable) => {
  return new Promise((resolve, reject) => {
    const subscription = observable.subscribe((invitation) => {
      assert((invitation == null ? void 0 : invitation.state) === Invitation.State.SUCCESS);
      subscription.unsubscribe();
      resolve(invitation);
    }, (err) => {
      subscription.unsubscribe();
      reject(err);
    });
  });
};

// packages/sdk/client/src/packlets/invitations/invitations-proxy.ts
import assert2 from "@dxos/node-std/assert";
import { PushStream } from "@dxos/async";
import { PublicKey } from "@dxos/keys";
import { Invitation as Invitation2 } from "@dxos/protocols/proto/dxos/client/services";
var createObservable = (rpcStream) => {
  const pushStream = new PushStream();
  rpcStream.subscribe((value) => {
    pushStream.next(value);
  }, (err) => {
    if (err) {
      pushStream.error(err);
    } else {
      pushStream.complete();
    }
  });
  return pushStream.observable;
};
var InvitationsProxy = class {
  // prettier-ignore
  constructor(_invitationsService, _getContext) {
    this._invitationsService = _invitationsService;
    this._getContext = _getContext;
  }
  getInvitationOptions() {
    return {
      invitationId: PublicKey.random().toHex(),
      type: Invitation2.Type.INTERACTIVE,
      authMethod: Invitation2.AuthMethod.SHARED_SECRET,
      state: Invitation2.State.INIT,
      swarmKey: PublicKey.random(),
      ...this._getContext()
    };
  }
  createInvitation(options) {
    const invitation = {
      ...this.getInvitationOptions(),
      ...options
    };
    const observable = new CancellableInvitationObservable({
      initialInvitation: invitation,
      subscriber: createObservable(this._invitationsService.createInvitation(invitation)),
      onCancel: async () => {
        const invitationId = observable.get().invitationId;
        assert2(invitationId, "Invitation missing identifier");
        await this._invitationsService.cancelInvitation({
          invitationId
        });
      }
    });
    return observable;
  }
  acceptInvitation(invitation) {
    assert2(invitation && invitation.swarmKey);
    const observable = new AuthenticatingInvitationObservable({
      initialInvitation: invitation,
      subscriber: createObservable(this._invitationsService.acceptInvitation({
        ...invitation
      })),
      onCancel: async () => {
        const invitationId = observable.get().invitationId;
        assert2(invitationId, "Invitation missing identifier");
        await this._invitationsService.cancelInvitation({
          invitationId
        });
      },
      onAuthenticate: async (authCode) => {
        const invitationId = observable.get().invitationId;
        assert2(invitationId, "Invitation missing identifier");
        await this._invitationsService.authenticate({
          invitationId,
          authCode
        });
      }
    });
    return observable;
  }
};

// packages/sdk/client/src/packlets/proto/gen/schema.ts
import * as dxos_echo_schema from "@dxos/echo-schema";
var schemaJson = '{"nested":{"dxos":{"nested":{"sdk":{"nested":{"client":{"nested":{"Properties":{"options":{"(object)":true},"fields":{"name":{"type":"string","id":1}}}}}}}}}}}';
var schema2 = dxos_echo_schema.EchoSchema.fromJson(schemaJson);
var _Properties = class extends dxos_echo_schema.TypedObject {
  static filter(opts) {
    return _Properties.type.createFilter(opts);
  }
  constructor(opts) {
    super({
      ...opts
    }, _Properties.type);
  }
};
var Properties = _Properties;
Properties.type = schema2.getType("dxos.sdk.client.Properties");
schema2.registerPrototype(Properties);

// packages/sdk/client/src/packlets/proxies/space-proxy.ts
import isEqual from "lodash.isequal";
import isEqualWith from "lodash.isequalwith";
import assert3 from "@dxos/node-std/assert";
import { Event, MulticastObservable as MulticastObservable2, synchronized, Trigger } from "@dxos/async";
import { cancelWithContext, Context } from "@dxos/context";
import { loadashEqualityFn, todo } from "@dxos/debug";
import { DatabaseProxy, ItemManager } from "@dxos/echo-db";
import { EchoDatabase } from "@dxos/echo-schema";
import { ApiError } from "@dxos/errors";
import { log as log2 } from "@dxos/log";
import { Invitation as Invitation3, SpaceState } from "@dxos/protocols/proto/dxos/client/services";
var __decorate = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var META_LOAD_TIMEOUT = 3e3;
var SpaceProxy = class {
  // prettier-ignore
  constructor(_clientServices, _modelFactory, _data, databaseRouter) {
    var _a, _b;
    this._clientServices = _clientServices;
    this._modelFactory = _modelFactory;
    this._data = _data;
    this._ctx = new Context();
    this._stateUpdate = new Event();
    this._pipelineUpdate = new Event();
    this._databaseInitialized = new Trigger();
    this._initializationComplete = new Trigger();
    this._initializing = false;
    this._initialized = false;
    this._invitationsUpdate = new Event();
    this._membersUpdate = new Event();
    this._state = MulticastObservable2.from(this._stateUpdate, SpaceState.CLOSED);
    this._pipeline = MulticastObservable2.from(this._pipelineUpdate, {});
    this._invitations = MulticastObservable2.from(this._invitationsUpdate, []);
    this._members = MulticastObservable2.from(this._membersUpdate, []);
    this._cachedProperties = new Properties({
      name: "Loading..."
    });
    assert3(this._clientServices.services.InvitationsService, "InvitationsService not available");
    this._invitationProxy = new InvitationsProxy(this._clientServices.services.InvitationsService, () => ({
      kind: Invitation3.Kind.SPACE,
      spaceKey: this.key
    }));
    assert3(this._clientServices.services.DataService, "DataService not available");
    this._dbBackend = new DatabaseProxy(this._clientServices.services.DataService, this.key);
    this._itemManager = new ItemManager(this._modelFactory);
    this._db = new EchoDatabase(this._itemManager, this._dbBackend, databaseRouter);
    this._internal = {
      db: this._dbBackend
    };
    databaseRouter.register(this.key, this._db);
    this._stateUpdate.emit(this._currentState);
    this._pipelineUpdate.emit((_a = _data.pipeline) != null ? _a : {});
    this._membersUpdate.emit((_b = _data.members) != null ? _b : []);
  }
  get key() {
    return this._data.spaceKey;
  }
  get isOpen() {
    return this._data.state === SpaceState.READY && this._initialized;
  }
  /**
  * Current state of the space.
  * The database is ready to be used in `SpaceState.READY` state.
  * Presence is available in `SpaceState.INACTIVE` state.
  */
  get _currentState() {
    if (this._data.state === SpaceState.READY && !this._initialized) {
      return SpaceState.INITIALIZING;
    } else {
      return this._data.state;
    }
  }
  get db() {
    return this._db;
  }
  get properties() {
    if (this._currentState !== SpaceState.READY) {
      return this._cachedProperties;
    } else {
      assert3(this._properties, "Properties not initialized.");
      return this._properties;
    }
  }
  get state() {
    return this._state;
  }
  /**
  * @inheritdoc
  */
  get pipeline() {
    return this._pipeline;
  }
  /**
  * @inheritdoc
  */
  get invitations() {
    return this._invitations;
  }
  /**
  * @inheritdoc
  */
  get members() {
    return this._members;
  }
  /**
  * @inheritdoc
  */
  // TODO(burdon): Remove?
  get internal() {
    return this._internal;
  }
  /**
  * Called by EchoProxy to update this space instance.
  * Called once on initial creation.
  * @internal Package-private.
  */
  async _processSpaceUpdate(space) {
    var _a;
    const emitEvent = shouldUpdate(this._data, space);
    const emitPipelineEvent = shouldPipelineUpdate(this._data, space);
    const emitMembersEvent = shouldMembersUpdate(this._data.members, space.members);
    this._data = space;
    log2("update", {
      space,
      emitEvent
    }, {
      file: "space-proxy.ts",
      line: 243,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    if (space.state === SpaceState.READY && !(this._initialized || this._initializing)) {
      await this._initialize();
    }
    if (emitEvent) {
      this._stateUpdate.emit(this._currentState);
    }
    if (emitPipelineEvent) {
      this._pipelineUpdate.emit((_a = space.pipeline) != null ? _a : {});
    }
    if (emitMembersEvent) {
      this._membersUpdate.emit(space.members);
    }
  }
  async _initialize() {
    if (this._initializing || this._initialized) {
      return;
    }
    log2("initializing...", {}, {
      file: "space-proxy.ts",
      line: 264,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    this._initializing = true;
    await this._dbBackend.open(this._itemManager, this._modelFactory);
    log2("ready", {}, {
      file: "space-proxy.ts",
      line: 270,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    this._databaseInitialized.wake();
    {
      const query = this._db.query(Properties.filter());
      if (query.objects.length === 1) {
        this._properties = query.objects[0];
      } else {
        const waitForSpaceMeta = new Trigger();
        const subscription = query.subscribe((query2) => {
          if (query2.objects.length === 1) {
            this._properties = query2.objects[0];
            waitForSpaceMeta.wake();
            subscription();
          }
        });
        try {
          await waitForSpaceMeta.wait({
            timeout: META_LOAD_TIMEOUT
          });
        } catch (e) {
          throw new ApiError("Properties not found.");
        } finally {
          subscription();
        }
      }
    }
    assert3(this._properties);
    this._initialized = true;
    this._initializing = false;
    this._initializationComplete.wake();
    this._stateUpdate.emit(this._currentState);
    this._data.members && this._membersUpdate.emit(this._data.members);
    log2("initialized", {}, {
      file: "space-proxy.ts",
      line: 304,
      scope: this,
      callSite: (f, a) => f(...a)
    });
  }
  /**
  * Called by EchoProxy close.
  * @internal Package-private.
  */
  async _destroy() {
    var _a, _b;
    log2("destroying...", {}, {
      file: "space-proxy.ts",
      line: 313,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    await this._ctx.dispose();
    await ((_a = this._dbBackend) == null ? void 0 : _a.close());
    await ((_b = this._itemManager) == null ? void 0 : _b.destroy());
    log2("destroyed", {}, {
      file: "space-proxy.ts",
      line: 317,
      scope: this,
      callSite: (f, a) => f(...a)
    });
  }
  /**
  * TODO
  */
  async open() {
    await this._setOpen(true);
  }
  /**
  * TODO
  */
  async close() {
    await this._setOpen(false);
  }
  /**
  * Waits until the space is in the ready state, with database initialized.
  */
  async waitUntilReady() {
    await cancelWithContext(this._ctx, this._initializationComplete.wait());
    return this;
  }
  /**
  * Post a message to the space.
  */
  async postMessage(channel, message) {
    assert3(this._clientServices.services.SpacesService, "SpacesService not available");
    await this._clientServices.services.SpacesService.postMessage({
      spaceKey: this.key,
      channel,
      message: {
        ...message,
        "@type": message["@type"] || "google.protobuf.Struct"
      }
    });
  }
  /**
  * Listen for messages posted to the space.
  */
  listen(channel, callback) {
    assert3(this._clientServices.services.SpacesService, "SpacesService not available");
    const stream = this._clientServices.services.SpacesService.subscribeMessages({
      spaceKey: this.key,
      channel
    });
    stream.subscribe(callback);
    return () => stream.close();
  }
  /**
  * Creates an interactive invitation.
  */
  createInvitation(options) {
    log2("create invitation", options, {
      file: "space-proxy.ts",
      line: 368,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    const invitation = this._invitationProxy.createInvitation(options);
    this._invitationsUpdate.emit([
      ...this._invitations.get(),
      invitation
    ]);
    return invitation;
  }
  /**
  * Remove invitation from space.
  */
  removeInvitation(id) {
    var _a;
    log2("remove invitation", {
      id
    }, {
      file: "space-proxy.ts",
      line: 379,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    const invitations = this._invitations.get();
    const index = invitations.findIndex((invitation) => invitation.get().invitationId === id);
    void ((_a = invitations[index]) == null ? void 0 : _a.cancel());
    this._invitationsUpdate.emit([
      ...invitations.slice(0, index),
      ...invitations.slice(index + 1)
    ]);
  }
  /**
  * Implementation method.
  */
  createSnapshot() {
    return todo();
  }
  async _setOpen(open) {
    return todo();
  }
};
__decorate([
  synchronized
], SpaceProxy.prototype, "_processSpaceUpdate", null);
__decorate([
  synchronized
], SpaceProxy.prototype, "_destroy", null);
var shouldUpdate = (prev, next) => {
  return prev.state !== next.state;
};
var shouldPipelineUpdate = (prev, next) => {
  return !isEqualWith(prev.pipeline, next.pipeline, loadashEqualityFn);
};
var shouldMembersUpdate = (prev, next) => {
  if (!next) {
    return false;
  }
  return !isEqual(prev, next);
};

// packages/sdk/client/src/packlets/proxies/echo-proxy.ts
var EchoProxy = class {
  // prettier-ignore
  constructor(_serviceProvider, _modelFactory) {
    this._serviceProvider = _serviceProvider;
    this._modelFactory = _modelFactory;
    this._spacesChanged = new Event2();
    this._spaceCreated = new Event2();
    this._spaces = MulticastObservable3.from(this._spacesChanged, []);
    this._spacesMap = new ComplexMap(PublicKey2.hash);
    this.dbRouter = new DatabaseRouter();
    this._destroying = false;
    this._instanceId = PublicKey2.random().toHex();
  }
  [inspect.custom]() {
    return inspectObject(this);
  }
  toJSON() {
    return {
      spaces: this._spacesMap.size
    };
  }
  /**
  * @deprecated
  */
  get modelFactory() {
    return this._modelFactory;
  }
  /**
  * @deprecated
  */
  get networkManager() {
    if (this._serviceProvider instanceof ClientServicesProxy) {
      throw new SystemError("Network manager not available in service proxy.");
    }
    return this._serviceProvider.echo.networkManager;
  }
  // TODO(burdon): ???
  get opened() {
    return this._invitationProxy !== void 0;
  }
  get spaces() {
    return this._spaces;
  }
  async open() {
    log3.trace("dxos.sdk.echo-proxy", trace.begin({
      id: this._instanceId,
      parentId: this._traceParent
    }), {
      file: "echo-proxy.ts",
      line: 107,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    this._ctx = new Context2();
    assert4(this._serviceProvider.services.SpacesService, "SpacesService is not available.");
    assert4(this._serviceProvider.services.InvitationsService, "InvitationsService is not available.");
    this._invitationProxy = new InvitationsProxy(this._serviceProvider.services.InvitationsService, () => ({
      kind: Invitation4.Kind.SPACE
    }));
    const gotInitialUpdate = new Trigger2();
    const spacesStream = this._serviceProvider.services.SpacesService.querySpaces();
    spacesStream.subscribe(async (data) => {
      var _a;
      let emitUpdate = false;
      for (const space of (_a = data.spaces) != null ? _a : []) {
        if (this._ctx.disposed) {
          return;
        }
        let spaceProxy = this._spacesMap.get(space.spaceKey);
        if (!spaceProxy) {
          spaceProxy = new SpaceProxy(this._serviceProvider, this._modelFactory, space, this.dbRouter);
          spaceProxy._stateUpdate.on(this._ctx, () => this._updateSpaceList());
          this._spacesMap.set(spaceProxy.key, spaceProxy);
          this._spaceCreated.emit(spaceProxy.key);
          emitUpdate = true;
        }
        scheduleTask(this._ctx, async () => {
          await spaceProxy._processSpaceUpdate(space);
        });
      }
      gotInitialUpdate.wake();
      if (emitUpdate) {
        this._updateSpaceList();
      }
    });
    this._ctx.onDispose(() => spacesStream.close());
    await gotInitialUpdate.wait();
  }
  async close() {
    await this._ctx.dispose();
    for (const space of this._spacesMap.values()) {
      await space._destroy();
    }
    this._spacesMap.clear();
    this._spacesChanged.emit([]);
    this._invitationProxy = void 0;
    log3.trace("dxos.sdk.echo-proxy", trace.end({
      id: this._instanceId
    }), {
      file: "echo-proxy.ts",
      line: 169,
      scope: this,
      callSite: (f, a) => f(...a)
    });
  }
  addSchema(schema5) {
    this.dbRouter.addSchema(schema5);
  }
  //
  // Spaces.
  //
  _updateSpaceList() {
    this._spacesChanged.emit(Array.from(this._spacesMap.values()));
  }
  /**
  * Creates a new space.
  */
  async createSpace(meta) {
    var _a;
    assert4(this._serviceProvider.services.SpacesService, "SpacesService is not available.");
    const space = await this._serviceProvider.services.SpacesService.createSpace();
    await this._spaceCreated.waitForCondition(() => {
      return this._spacesMap.has(space.spaceKey);
    });
    const spaceProxy = (_a = this._spacesMap.get(space.spaceKey)) != null ? _a : failUndefined();
    await spaceProxy._databaseInitialized.wait({
      timeout: 3e3
    });
    spaceProxy.db.add(new Properties(meta));
    await spaceProxy.db.flush();
    await spaceProxy._initializationComplete.wait();
    return spaceProxy;
  }
  /**
  * Clones the space from a snapshot.
  * @internal
  */
  async cloneSpace(snapshot) {
    return todo2();
  }
  /**
  * Returns an individual space by its key.
  */
  getSpace(spaceKey) {
    return this._spacesMap.get(spaceKey);
  }
  /**
  * Initiates an interactive accept invitation flow.
  */
  // TODO(wittjosiah): Make idempotent.
  acceptInvitation(invitation) {
    if (!this.opened) {
      throw new ApiError2("Client not open.");
    }
    log3("accept invitation", invitation, {
      file: "echo-proxy.ts",
      line: 242,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    return this._invitationProxy.acceptInvitation(invitation);
  }
};

// packages/sdk/client/src/packlets/proxies/halo-proxy.ts
import assert5 from "@dxos/node-std/assert";
import { inspect as inspect2 } from "@dxos/node-std/util";
import { asyncTimeout, Event as Event3, EventSubscriptions, MulticastObservable as MulticastObservable4, observableError, ObservableProvider, Trigger as Trigger3 } from "@dxos/async";
import { inspectObject as inspectObject2 } from "@dxos/debug";
import { ApiError as ApiError3 } from "@dxos/errors";
import { PublicKey as PublicKey3 } from "@dxos/keys";
import { log as log4 } from "@dxos/log";
import { trace as trace2 } from "@dxos/protocols";
import { DeviceKind, Invitation as Invitation5 } from "@dxos/protocols/proto/dxos/client/services";
var THROW_TIMEOUT_ERROR_AFTER = 3e3;
var HaloProxy = class {
  // prettier-ignore
  constructor(_serviceProvider) {
    this._serviceProvider = _serviceProvider;
    this._subscriptions = new EventSubscriptions();
    this._devicesChanged = new Event3();
    this._contactsChanged = new Event3();
    this._invitationsUpdate = new Event3();
    this._identityChanged = new Event3();
    this._identity = MulticastObservable4.from(this._identityChanged, null);
    this._devices = MulticastObservable4.from(this._devicesChanged, []);
    this._contacts = MulticastObservable4.from(this._contactsChanged, []);
    this._invitations = MulticastObservable4.from(this._invitationsUpdate, []);
    this._instanceId = PublicKey3.random().toHex();
  }
  [inspect2.custom]() {
    return inspectObject2(this);
  }
  toJSON() {
    var _a, _b;
    return {
      identityKey: (_a = this._identity.get()) == null ? void 0 : _a.identityKey.truncate(),
      deviceKey: (_b = this.device) == null ? void 0 : _b.deviceKey.truncate()
    };
  }
  /**
  * User identity info.
  */
  get identity() {
    return this._identity;
  }
  get devices() {
    return this._devices;
  }
  get device() {
    return this._devices.get().find((device) => device.kind === DeviceKind.CURRENT);
  }
  get contacts() {
    return this._contacts;
  }
  get invitations() {
    return this._invitations;
  }
  // TODO(burdon): Standardize isOpen, etc.
  get opened() {
    return this._invitationProxy !== void 0;
  }
  /**
  * Allocate resources and set-up internal subscriptions.
  *
  * @internal
  */
  async _open() {
    log4.trace("dxos.sdk.halo-proxy", trace2.begin({
      id: this._instanceId,
      parentId: this._traceParent
    }), {
      file: "halo-proxy.ts",
      line: 119,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    const gotIdentity = this._identityChanged.waitForCount(1);
    assert5(this._serviceProvider.services.InvitationsService, "InvitationsService not available");
    this._invitationProxy = new InvitationsProxy(this._serviceProvider.services.InvitationsService, () => ({
      kind: Invitation5.Kind.DEVICE
    }));
    assert5(this._serviceProvider.services.IdentityService, "IdentityService not available");
    const identityStream = this._serviceProvider.services.IdentityService.queryIdentity();
    identityStream.subscribe((data) => {
      var _a;
      this._identityChanged.emit((_a = data.identity) != null ? _a : null);
    });
    assert5(this._serviceProvider.services.DevicesService, "DevicesService not available");
    const devicesStream = this._serviceProvider.services.DevicesService.queryDevices();
    devicesStream.subscribe((data) => {
      if (data.devices) {
        this._devicesChanged.emit(data.devices);
      }
    });
    this._subscriptions.add(() => identityStream.close());
    await Promise.all([
      gotIdentity
    ]);
  }
  /**
  * Destroy the instance and clean-up subscriptions.
  *
  * @internal
  */
  async _close() {
    this._subscriptions.clear();
    this._invitationProxy = void 0;
    this._identityChanged.emit(null);
    this._devicesChanged.emit([]);
    this._contactsChanged.emit([]);
    this._invitationsUpdate.emit([]);
    log4.trace("dxos.sdk.halo-proxy", trace2.end({
      id: this._instanceId
    }), {
      file: "halo-proxy.ts",
      line: 167,
      scope: this,
      callSite: (f, a) => f(...a)
    });
  }
  /**
  * @internal
  */
  // TODO(wittjosiah): Should `Observable` class support this?
  _waitForIdentity() {
    return this._identityChanged.waitForCondition(() => !!this._identity.get());
  }
  /**
  * Create Identity.
  * Then initializes profile with given display name.
  */
  async createIdentity(profile = {}) {
    assert5(this._serviceProvider.services.IdentityService, "IdentityService not available");
    const identity = await this._serviceProvider.services.IdentityService.createIdentity(profile);
    this._identityChanged.emit(identity);
    return identity;
  }
  async recoverIdentity(recoveryKey) {
    assert5(this._serviceProvider.services.IdentityService, "IdentityService not available");
    const identity = await this._serviceProvider.services.IdentityService.recoverIdentity({
      recoveryKey
    });
    this._identityChanged.emit(identity);
    return identity;
  }
  /**
  * Get Halo credentials for the current user.
  */
  // TODO(wittjosiah): Get/Subscribe.
  queryCredentials({ ids, type } = {}) {
    const identity = this._identity.get();
    if (!identity) {
      throw new ApiError3("Identity is not available.");
    }
    if (!this._serviceProvider.services.SpacesService) {
      throw new ApiError3("SpacesService is not available.");
    }
    const stream = this._serviceProvider.services.SpacesService.queryCredentials({
      spaceKey: identity.spaceKey
    });
    this._subscriptions.add(() => stream.close());
    const observable = new ObservableProvider();
    const credentials = [];
    stream.subscribe((credential) => {
      var _a;
      credentials.push(credential);
      const newCredentials = credentials.filter((c) => !ids || c.id && ids.some((id) => id.equals(c.id))).filter((c) => !type || c.subject.assertion["@type"] === type);
      if (newCredentials.length !== ((_a = observable.value) == null ? void 0 : _a.length) || !newCredentials.every((credential2, index) => credential2.id && observable.value[index] && credential2.id.equals(observable.value[index].id))) {
        observable.setValue(newCredentials);
        observable.callback.onUpdate(newCredentials);
      }
    }, (err) => {
      if (err) {
        observableError(observable, err);
      }
    });
    return observable;
  }
  /**
  * Initiates device invitation.
  */
  createInvitation(options) {
    if (!this.opened) {
      throw new ApiError3("Client not open.");
    }
    log4("create invitation", options, {
      file: "halo-proxy.ts",
      line: 256,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    const invitation = this._invitationProxy.createInvitation(options);
    this._invitationsUpdate.emit([
      ...this._invitations.get(),
      invitation
    ]);
    return invitation;
  }
  /**
  * Removes device invitation.
  */
  removeInvitation(id) {
    var _a;
    log4("remove invitation", {
      id
    }, {
      file: "halo-proxy.ts",
      line: 267,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    const invitations = this._invitations.get();
    const index = invitations.findIndex((invitation) => invitation.get().invitationId === id);
    void ((_a = invitations[index]) == null ? void 0 : _a.cancel());
    this._invitationsUpdate.emit([
      ...invitations.slice(0, index),
      ...invitations.slice(index + 1)
    ]);
  }
  /**
  * Initiates accepting invitation.
  */
  acceptInvitation(invitation) {
    if (!this.opened) {
      throw new ApiError3("Client not open.");
    }
    log4("accept invitation", invitation, {
      file: "halo-proxy.ts",
      line: 282,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    return this._invitationProxy.acceptInvitation(invitation);
  }
  /**
  * Write credentials to halo profile.
  */
  async writeCredentials(credentials) {
    const identity = this._identity.get();
    if (!identity) {
      throw new ApiError3("Identity is not available.");
    }
    if (!this._serviceProvider.services.SpacesService) {
      throw new ApiError3("SpacesService is not available.");
    }
    return this._serviceProvider.services.SpacesService.writeCredentials({
      spaceKey: identity.spaceKey,
      credentials
    });
  }
  /**
  * Present Credentials.
  */
  async presentCredentials({ ids, nonce }) {
    if (!this._serviceProvider.services.IdentityService) {
      throw new ApiError3("IdentityService is not available.");
    }
    const trigger = new Trigger3();
    this.queryCredentials({
      ids
    }).subscribe({
      onUpdate: (credentials2) => {
        if (credentials2.every((credential) => ids.some((id) => id.equals(credential.id))) && ids.every((id) => credentials2.some((credential) => id.equals(credential.id)))) {
          trigger.wake(credentials2);
        }
      },
      onError: (err) => {
        log4.catch(err, {}, {
          file: "halo-proxy.ts",
          line: 321,
          scope: this,
          callSite: (f, a) => f(...a)
        });
      }
    });
    const credentials = await asyncTimeout(trigger.wait(), THROW_TIMEOUT_ERROR_AFTER, new ApiError3("Timeout while waiting for credentials"));
    return this._serviceProvider.services.IdentityService.signPresentation({
      presentation: {
        credentials
      },
      nonce
    });
  }
};

// packages/sdk/client/src/packlets/proxies/mesh-proxy.ts
import assert6 from "@dxos/node-std/assert";
import { Event as Event4, MulticastObservable as MulticastObservable5 } from "@dxos/async";
import { Context as Context3 } from "@dxos/context";
import { PublicKey as PublicKey4 } from "@dxos/keys";
import { log as log5 } from "@dxos/log";
import { trace as trace3 } from "@dxos/protocols";
import { ConnectionState } from "@dxos/protocols/proto/dxos/client/services";
var MeshProxy = class {
  // prettier-ignore
  constructor(_serviceProvider) {
    this._serviceProvider = _serviceProvider;
    this._networkStatusUpdated = new Event4();
    this._networkStatus = MulticastObservable5.from(this._networkStatusUpdated, {
      state: ConnectionState.OFFLINE
    });
    this._instanceId = PublicKey4.random().toHex();
  }
  toJSON() {
    return {
      networkStatus: this._networkStatus.get()
    };
  }
  get networkStatus() {
    return this._networkStatus;
  }
  async setConnectionState(state) {
    assert6(this._serviceProvider.services.NetworkService, "NetworkService is not available.");
    return this._serviceProvider.services.NetworkService.setNetworkOptions({
      state
    });
  }
  /**
  * @internal
  */
  async _open() {
    log5.trace("dxos.sdk.mesh-proxy", trace3.begin({
      id: this._instanceId,
      parentId: this._traceParent
    }), {
      file: "mesh-proxy.ts",
      line: 57,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    this._ctx = new Context3({
      onError: (err) => log5.catch(err, {}, {
        file: "mesh-proxy.ts",
        line: 58,
        scope: this,
        callSite: (f, a) => f(...a)
      })
    });
    assert6(this._serviceProvider.services.NetworkService, "NetworkService is not available.");
    const networkStatusStream = this._serviceProvider.services.NetworkService.subscribeToNetworkStatus();
    networkStatusStream.subscribe((networkStatus) => {
      this._networkStatusUpdated.emit(networkStatus);
    });
    this._ctx.onDispose(() => {
      networkStatusStream.close();
    });
  }
  /**
  * @internal
  */
  async _close() {
    var _a;
    await ((_a = this._ctx) == null ? void 0 : _a.dispose());
    log5.trace("dxos.sdk.mesh-proxy", trace3.end({
      id: this._instanceId
    }), {
      file: "mesh-proxy.ts",
      line: 76,
      scope: this,
      callSite: (f, a) => f(...a)
    });
  }
};

// packages/sdk/client/src/packlets/proxies/shell-controller.ts
import { Event as Event5 } from "@dxos/async";
import { log as log6 } from "@dxos/log";
import { ShellDisplay } from "@dxos/protocols/proto/dxos/iframe";
import { createProtoRpcPeer } from "@dxos/rpc";
var ShellController = class {
  constructor(_port) {
    this._port = _port;
    this.contextUpdate = new Event5();
    this._display = ShellDisplay.NONE;
  }
  get display() {
    return this._display;
  }
  async setLayout(layout, options = {}) {
    var _a;
    log6("set layout", {
      layout,
      ...options
    }, {
      file: "shell-controller.ts",
      line: 27,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    this._display = ShellDisplay.FULLSCREEN;
    this.contextUpdate.emit({
      display: this._display
    });
    await ((_a = this._shellRpc) == null ? void 0 : _a.rpc.ShellService.setLayout({
      layout,
      ...options
    }));
  }
  async open() {
    this._shellRpc = createProtoRpcPeer({
      requested: shellServiceBundle,
      exposed: appServiceBundle,
      handlers: {
        AppService: {
          setContext: async (request) => {
            log6("set context", request, {
              file: "shell-controller.ts",
              line: 40,
              scope: this,
              callSite: (f, a) => f(...a)
            });
            this._display = request.display;
            this.contextUpdate.emit(request);
          }
        }
      },
      port: this._port
    });
    await this._shellRpc.open();
  }
  async close() {
    var _a;
    await ((_a = this._shellRpc) == null ? void 0 : _a.close());
    this._shellRpc = void 0;
  }
};

// packages/sdk/client/src/packlets/client/serializer.ts
import { schema as schema3 } from "@dxos/protocols";
var spaceCodec = schema3.getCodecForType("dxos.echo.snapshot.SpaceSnapshot");
var SpaceSerializer = class {
  // prettier-ignore
  constructor(_echo) {
    this._echo = _echo;
  }
  async serializeSpace(space) {
    const snapshot = await space.createSnapshot();
    return new Blob([
      spaceCodec.encode(snapshot)
    ]);
  }
  async deserializeSpace(data) {
    return await this._echo.cloneSpace(spaceCodec.decode(data));
  }
};

// packages/sdk/client/src/packlets/client/utils.ts
import { Config } from "@dxos/config";
import { ApiError as ApiError4 } from "@dxos/errors";

// packages/sdk/client/src/packlets/client/iframe-service-proxy.ts
import { Event as Event6 } from "@dxos/async";
import { RemoteServiceConnectionTimeout as RemoteServiceConnectionTimeout2 } from "@dxos/errors";
import { PublicKey as PublicKey5 } from "@dxos/keys";
import { log as log7 } from "@dxos/log";
import { trace as trace4 } from "@dxos/protocols";
import { ShellDisplay as ShellDisplay2, ShellLayout } from "@dxos/protocols/proto/dxos/iframe";
import { createIFrame, createIFramePort } from "@dxos/rpc-tunnel";

// packages/sdk/client/src/packlets/client/config.ts
var DEFAULT_CLIENT_CHANNEL = "dxos:app";
var DEFAULT_SHELL_CHANNEL = "dxos:shell";
var DEFAULT_CLIENT_ORIGIN = false ? "https://halo.dxos.org/vault.html" : "http://localhost:3967/vault.html";
var EXPECTED_CONFIG_VERSION = 1;
var defaultConfig = {
  version: 1
};

// packages/sdk/client/src/packlets/client/service-proxy.ts
import { asyncTimeout as asyncTimeout2 } from "@dxos/async";
import { RemoteServiceConnectionTimeout } from "@dxos/errors";
import { createProtoRpcPeer as createProtoRpcPeer2 } from "@dxos/rpc";

// packages/sdk/client/src/packlets/client/service-definitions.ts
import { schema as schema4 } from "@dxos/protocols";
import { createServiceBundle } from "@dxos/rpc";
var clientServiceBundle = createServiceBundle({
  SystemService: schema4.getService("dxos.client.services.SystemService"),
  IdentityService: schema4.getService("dxos.client.services.IdentityService"),
  InvitationsService: schema4.getService("dxos.client.services.InvitationsService"),
  DevicesService: schema4.getService("dxos.client.services.DevicesService"),
  SpacesService: schema4.getService("dxos.client.services.SpacesService"),
  DataService: schema4.getService("dxos.echo.service.DataService"),
  NetworkService: schema4.getService("dxos.client.services.NetworkService"),
  // TODO(burdon): Deprecated.
  DevtoolsHost: schema4.getService("dxos.devtools.host.DevtoolsHost"),
  TracingService: schema4.getService("dxos.devtools.host.TracingService")
});
var iframeServiceBundle = {
  IframeService: schema4.getService("dxos.iframe.IframeService"),
  BridgeService: schema4.getService("dxos.mesh.bridge.BridgeService")
};
var workerServiceBundle = {
  WorkerService: schema4.getService("dxos.iframe.WorkerService")
};
var appServiceBundle = {
  AppService: schema4.getService("dxos.iframe.AppService")
};
var shellServiceBundle = {
  ShellService: schema4.getService("dxos.iframe.ShellService")
};

// packages/sdk/client/src/packlets/client/service-proxy.ts
var ClientServicesProxy = class {
  // prettier-ignore
  constructor(port2, _timeout = 3e4) {
    this._timeout = _timeout;
    this._proxy = createProtoRpcPeer2({
      requested: clientServiceBundle,
      exposed: {},
      handlers: {},
      port: port2
    });
  }
  get proxy() {
    return this._proxy;
  }
  get descriptors() {
    return clientServiceBundle;
  }
  get services() {
    return this._proxy.rpc;
  }
  async open() {
    await asyncTimeout2(this._proxy.open(), this._timeout, new RemoteServiceConnectionTimeout());
  }
  async close() {
    await this._proxy.close();
  }
};

// packages/sdk/client/src/packlets/client/iframe-service-proxy.ts
var shellStyles = Object.entries({
  display: "none",
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  border: 0,
  "z-index": 1e6
}).reduce((acc, [key, value]) => `${acc}${key}: ${value};`, "");
var IFrameClientServicesProxy = class {
  constructor({ source = DEFAULT_CLIENT_ORIGIN, channel = DEFAULT_CLIENT_CHANNEL, shell = DEFAULT_SHELL_CHANNEL, timeout = 1e3 } = {}) {
    this.joinedSpace = new Event6();
    /**
    * Unique id.
    */
    this._instanceId = PublicKey5.random().toHex();
    this._handleKeyDown = this._handleKeyDown.bind(this);
    this._options = {
      source,
      channel,
      shell,
      timeout
    };
  }
  get proxy() {
    return this._clientServicesProxy.proxy;
  }
  get descriptors() {
    return this._clientServicesProxy.descriptors;
  }
  get services() {
    return this._clientServicesProxy.services;
  }
  get display() {
    var _a;
    return (_a = this._shellController) == null ? void 0 : _a.display;
  }
  get contextUpdate() {
    var _a;
    return (_a = this._shellController) == null ? void 0 : _a.contextUpdate;
  }
  setSpaceProvider(provider) {
    this._spaceProvider = provider;
  }
  async setLayout(layout, options = {}) {
    var _a;
    await ((_a = this._shellController) == null ? void 0 : _a.setLayout(layout, options));
  }
  async open() {
    var _a;
    log7.trace("dxos.sdk.iframe-client-services-proxy", trace4.begin({
      id: this._instanceId
    }), {
      file: "iframe-service-proxy.ts",
      line: 94,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    if (!this._clientServicesProxy) {
      this._clientServicesProxy = new ClientServicesProxy(await this._getIFramePort(this._options.channel));
    }
    if (!this._shellController && typeof this._options.shell === "string") {
      this._shellController = new ShellController(await this._getIFramePort(this._options.shell));
      this._iframe.setAttribute("style", shellStyles);
      this._iframe.setAttribute("data-testid", "dxos-shell");
      this._shellController.contextUpdate.on(({ display, spaceKey }) => {
        this._iframe.style.display = display === ShellDisplay2.NONE ? "none" : "";
        if (display === ShellDisplay2.NONE) {
          this._iframe.blur();
        }
        spaceKey && this.joinedSpace.emit(spaceKey);
      });
      window.addEventListener("keydown", this._handleKeyDown);
    }
    await this._clientServicesProxy.open();
    await ((_a = this._shellController) == null ? void 0 : _a.open());
    if (!this._shellController) {
      return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    const spaceInvitationCode = searchParams.get("spaceInvitationCode");
    if (spaceInvitationCode) {
      await this._shellController.setLayout(ShellLayout.JOIN_SPACE, {
        invitationCode: spaceInvitationCode
      });
      return;
    }
    const haloInvitationCode = searchParams.get("haloInvitationCode");
    if (haloInvitationCode) {
      await this._shellController.setLayout(ShellLayout.INITIALIZE_IDENTITY, {
        invitationCode: haloInvitationCode != null ? haloInvitationCode : void 0
      });
    }
  }
  async close() {
    var _a, _b;
    window.removeEventListener("keydown", this._handleKeyDown);
    await ((_a = this._shellController) == null ? void 0 : _a.close());
    await ((_b = this._clientServicesProxy) == null ? void 0 : _b.close());
    this._shellController = void 0;
    this._clientServicesProxy = void 0;
    if (this._iframe) {
      this._iframe.remove();
      this._iframe = void 0;
    }
    log7.trace("dxos.sdk.iframe-client-services-proxy", trace4.end({
      id: this._instanceId
    }), {
      file: "iframe-service-proxy.ts",
      line: 147,
      scope: this,
      callSite: (f, a) => f(...a)
    });
  }
  async _getIFramePort(channel) {
    const source = new URL(typeof this._options.shell === "string" ? this._options.source : `${this._options.source}#disableshell`, window.location.origin);
    if (!this._iframe) {
      const iframeId = `__DXOS_CLIENT_${PublicKey5.random().toHex()}__`;
      this._iframe = createIFrame(source.toString(), iframeId, {
        allow: "clipboard-read; clipboard-write"
      });
      const res = await fetch(source);
      if (res.status >= 400) {
        throw new RemoteServiceConnectionTimeout2();
      }
    }
    return createIFramePort({
      origin: source.origin,
      iframe: this._iframe,
      channel
    });
  }
  async _handleKeyDown(event) {
    var _a;
    if (!this._shellController) {
      return;
    }
    const modifier = event.ctrlKey || event.metaKey;
    if (event.key === ">" && event.shiftKey && modifier) {
      await this._shellController.setLayout(ShellLayout.DEVICE_INVITATIONS);
    } else if (event.key === "." && modifier) {
      const spaceKey = await ((_a = this._spaceProvider) == null ? void 0 : _a.call(this));
      await this._shellController.setLayout(ShellLayout.SPACE_INVITATIONS, {
        spaceKey
      });
    }
  }
};

// packages/sdk/client/src/packlets/client/utils.ts
var fromIFrame = (config = new Config(), options = {}) => {
  if (typeof window === "undefined") {
    throw new ApiError4("Cannot configure IFrame bridge outside of browser environment.");
  }
  const source = config.get("runtime.client.remoteSource");
  return new IFrameClientServicesProxy({
    source,
    ...options
  });
};

// packages/sdk/client/src/packlets/client/client.ts
var __decorate2 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var createDefaultModelFactory = () => {
  return new ModelFactory().registerModel(DocumentModel).registerModel(TextModel);
};
var Client = class {
  // prettier-ignore
  constructor({ config, modelFactory, services } = {}) {
    /**
    * The version of this client API
    */
    this.version = DXOS_VERSION;
    // TODO(wittjosiah): Make `null` status part of enum.
    this._statusUpdate = new Event7();
    this._initialized = false;
    this._status = MulticastObservable6.from(this._statusUpdate, null);
    /**
    * Unique id of the Client, local to the current peer.
    */
    this._instanceId = PublicKey6.random().toHex();
    this._config = config != null ? config : new Config2();
    this._services = services != null ? services : fromIFrame(this._config);
    this._modelFactory = modelFactory != null ? modelFactory : createDefaultModelFactory();
    this._halo = new HaloProxy(this._services);
    this._echo = new EchoProxy(this._services, this._modelFactory);
    this._mesh = new MeshProxy(this._services);
    this._halo._traceParent = this._instanceId;
    this._echo._traceParent = this._instanceId;
    this._mesh._traceParent = this._instanceId;
    const filter = this.config.get("runtime.client.log.filter");
    if (filter) {
      const prefix = this.config.get("runtime.client.log.prefix");
      log8.config({
        filter,
        prefix
      }, {}, {
        file: "client.ts",
        line: 103,
        scope: this,
        callSite: (f, a) => f(...a)
      });
    }
  }
  [inspect3.custom]() {
    return inspectObject3(this);
  }
  toJSON() {
    return {
      initialized: this.initialized,
      echo: this._echo,
      halo: this._halo,
      mesh: this._mesh
    };
  }
  /**
  * Current configuration object
  */
  get config() {
    return this._config;
  }
  /**
  * Current client services provider.
  */
  get services() {
    return this._services;
  }
  // TODO(burdon): Rename isOpen.
  /**
  * Returns true if the client has been initialized. Initialize by calling `.initialize()`
  */
  get initialized() {
    return this._initialized;
  }
  /**
  * Client services system status.
  */
  get status() {
    return this._status;
  }
  /**
  * HALO credentials.
  */
  get halo() {
    return this._halo;
  }
  /**
  * MESH networking.
  */
  get mesh() {
    return this._mesh;
  }
  /**
  * @deprecated
  */
  get dbRouter() {
    return this._echo.dbRouter;
  }
  /**
  * ECHO spaces.
  */
  get spaces() {
    return this._echo.spaces;
  }
  addSchema(schema5) {
    return this._echo.addSchema(schema5);
  }
  /**
  * Creates a new space.
  */
  createSpace(meta) {
    return this._echo.createSpace(meta);
  }
  /**
  * Get an existing space by its key.
  */
  getSpace(spaceKey) {
    return this._echo.getSpace(spaceKey);
  }
  /**
  * Accept an invitation to a space.
  */
  acceptInvitation(invitation) {
    return this._echo.acceptInvitation(invitation);
  }
  /**
  * Initializes internal resources in an idempotent way.
  * Required before using the Client instance.
  */
  async initialize() {
    if (this._initialized) {
      return;
    }
    log8.trace("dxos.sdk.client", trace5.begin({
      id: this._instanceId
    }), {
      file: "client.ts",
      line: 212,
      scope: this,
      callSite: (f, a) => f(...a)
    });
    await this._services.open();
    if (typeof window !== "undefined") {
      await createDevtoolsRpcServer(this, this._services);
    }
    assert7(this._services.services.SystemService, "SystemService is not available.");
    const trigger = new Trigger4();
    this._statusStream = this._services.services.SystemService.queryStatus();
    this._statusStream.subscribe(async ({ status }) => {
      this._statusTimeout && clearTimeout(this._statusTimeout);
      trigger.wake(void 0);
      this._statusUpdate.emit(status);
      this._statusTimeout = setTimeout(() => {
        this._statusUpdate.emit(null);
      }, 5e3);
    }, (err2) => {
      trigger.wake(err2);
      this._statusUpdate.emit(null);
    });
    const err = await trigger.wait();
    if (err) {
      throw err;
    }
    await this._halo._open();
    await this._echo.open();
    await this._mesh._open();
    this._initialized = true;
  }
  /**
  * Cleanup, release resources.
  * Open/close is re-entrant.
  */
  async destroy() {
    if (!this._initialized) {
      return;
    }
    await this._halo._close();
    await this._echo.close();
    await this._mesh._close();
    this._statusTimeout && clearTimeout(this._statusTimeout);
    this._statusStream.close();
    await this._services.close();
    this._initialized = false;
    log8.trace("dxos.sdk.client", trace5.end({
      id: this._instanceId
    }), {
      file: "client.ts",
      line: 275,
      scope: this,
      callSite: (f, a) => f(...a)
    });
  }
  /**
  * Reinitialized the client session with the remote service host.
  * This is useful when connecting to a host running behind a resource lock
  * (e.g., HALO when SharedWorker is unavailable).
  */
  async resumeHostServices() {
    assert7(this._services.services.SystemService, "SystemService is not available.");
    await this._services.services.SystemService.updateStatus({
      status: SystemStatus.ACTIVE
    });
  }
  /**
  * Resets and destroys client storage.
  * Warning: Inconsistent state after reset, do not continue to use this client instance.
  */
  async reset() {
    var _a;
    if (!this._initialized) {
      throw new ApiError5("Client not open.");
    }
    assert7(this._services.services.SystemService, "SystemService is not available.");
    await ((_a = this._services.services) == null ? void 0 : _a.SystemService.reset());
    await this.destroy();
    this._initialized = false;
  }
  /**
  * @deprecated
  */
  createSerializer() {
    return new SpaceSerializer(this._echo);
  }
};
__decorate2([
  synchronized2
], Client.prototype, "initialize", null);
__decorate2([
  synchronized2
], Client.prototype, "destroy", null);
export {
  AUTHENTICATION_CODE_LENGTH,
  ApiError6 as ApiError,
  AuthenticatingInvitationObservable,
  CancellableInvitationObservable,
  Client,
  ClientServicesProxy,
  Config3 as Config,
  DEFAULT_CLIENT_CHANNEL,
  DEFAULT_CLIENT_ORIGIN,
  DEFAULT_SHELL_CHANNEL,
  DocumentModel2 as DocumentModel,
  EXPECTED_CONFIG_VERSION,
  EchoProxy,
  HaloProxy,
  IFrameClientServicesProxy,
  INVITATION_TIMEOUT,
  Invitation6 as Invitation,
  InvitationEncoder,
  InvitationsProxy,
  Item,
  ItemFilterDeleted,
  MeshProxy,
  ON_CLOSE_DELAY,
  Properties,
  PublicKey7 as PublicKey,
  ResultSet,
  Schema,
  ShellController,
  ShellDisplay3 as ShellDisplay,
  ShellLayout2 as ShellLayout,
  SpaceMember,
  SpaceProxy,
  SpaceSerializer,
  SpaceState2 as SpaceState,
  SystemStatus2 as SystemStatus,
  TYPE_SCHEMA,
  appServiceBundle,
  clientServiceBundle,
  createDefaultModelFactory,
  createDevtoolsRpcServer,
  defaultConfig,
  fromIFrame,
  generateSeedPhrase,
  iframeServiceBundle,
  shellServiceBundle,
  workerServiceBundle,
  wrapObservable
};
//# sourceMappingURL=index.mjs.map
